<template>
  <div id="app">
    <!--<pre style="z-index: 9999; float: left;position: fixed;top: 0;left: 0;height: 100%;overflow: auto;">{{ business }}</pre>-->
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'app',
  computed: {
    ...mapGetters('business', [
      'business'
    ])
  },
  created () {
    this.$store.dispatch('checkAuth')
  }
}
</script>

<style lang="scss">
  // Load CSS
  @import "/assets/sass/control-panel.scss";

  // Transitioning
  .component-fade-enter-active, .component-fade-leave-active {
    transition: opacity .25s ease;
  }
  .component-fade-enter, .component-fade-leave-to
  {
    opacity: 0;
  }
</style>



// WEBPACK FOOTER //
// app.vue?81c2a2c2